import React, { useEffect, useState } from 'react';
import { Empty, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import LkFooterComponent from '../../components/LkFooterComponent';
import { DocumentDocExpiredSvg, DocumentDocSvg, DocumentPdfSvg } from '../../icons';
import { BlueLayout } from '../../styles/styled';
import { DocumentPublicType } from '../EditDocumentCategoryPage/types';
import {
  ContentLayout,
  DocumentCategoriesContainer,
  DocumentCollapsableButton,
  DocumentContainerUI,
  FilesContainerUI,
} from './styled';

export const DocumentPage = () => {
  const [currentDocumentCategory, setCurrentDocumentCategory] = useState<DocumentPublicType | null>(null);
  const [collapsedDocumentsState, setCollapsedDocuments] = useState<number[]>([]);
  const { id } = useParams();

  const generateDocumentSvgFromString = (file_name: string) => {
    if (file_name.includes('pdf')) return <DocumentPdfSvg />;
    else if (file_name.includes('doc')) return <DocumentDocSvg />;
    else return <DocumentDocExpiredSvg />;
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const response = await api.get<DocumentPublicType>(endpoints.getPublicDocumentById(id));

          if (id) {
            setCurrentDocumentCategory(response.data);
          }
        } catch (err) {}
      })();
    }

    setCollapsedDocuments([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setCurrentDocumentCategory(null);
  }, []);

  return currentDocumentCategory ? (
    <DocumentCategoriesContainer>
      <BlueLayout padding="40px 0 10px 0">{currentDocumentCategory.title}</BlueLayout>
      {currentDocumentCategory.description && <ContentLayout>{currentDocumentCategory?.description}</ContentLayout>}
      {currentDocumentCategory?.documents.length === 0 && <Empty description="Данный раздел пуст" />}
      {currentDocumentCategory?.documents?.map((el, index) => (
        <DocumentContainerUI offBorders={index === 0} key={el.id} offDot column>
          <DocumentContainerUI offBorders paddingBottom="10px">
            <button
              onClick={() =>
                setCollapsedDocuments(
                  collapsedDocumentsState.includes(index)
                    ? collapsedDocumentsState.filter((e) => e !== index)
                    : [...collapsedDocumentsState, index],
                )
              }
              className="item"
            >
              {el.title}
              <DocumentCollapsableButton>
                {collapsedDocumentsState.includes(index) ? '—' : '+'}
              </DocumentCollapsableButton>
            </button>
          </DocumentContainerUI>
          {collapsedDocumentsState.includes(index) &&
            el.document_files.map((el) => {
              return (
                <FilesContainerUI key={el.id}>
                  <div className="left-side">
                    <div className="svg-container">{generateDocumentSvgFromString(el.file.file_path)}</div>
                    <a href={el.file.file_path} rel="noreferrer" target="_blank">
                      {el.name}
                    </a>
                  </div>
                </FilesContainerUI>
              );
            })}
        </DocumentContainerUI>
      ))}
      <LkFooterComponent />
    </DocumentCategoriesContainer>
  ) : (
    <Spin />
  );
};
